// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"06eeedb8","174":"633611ca","206":"1ff798c9","260":"ea9c0798","409":"2af5ee08","449":"7ac857dd","582":"4fb3a9a2","671":"81ba91ed"}[chunkId] + ".chunk.css";
};